/**
 * Autogenerated file.
 * For adding or changing icons, see README.MD
 */
import React from 'react';
import { createIcon } from '../../icon/create-icon'; // Outline

const ChevronLeftOutline = props => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  stroke: "var(--i-color)",
  strokeLinecap: props.strokeLinecap,
  strokeLinejoin: props.strokeLinejoin,
  strokeWidth: "var(--i-s-width)",
  d: "M15.75 19.5 8.25 12l7.5-7.5"
})); // Fill


const ChevronLeftFill = props => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  fill: "var(--i-color)",
  d: "M16.04 3.805a.776.776 0 0 0-.43-.04.737.737 0 0 0-.39.2l-7.5 7.5a.762.762 0 0 0 0 1.068l7.5 7.5a.758.758 0 0 0 1.16-.118.761.761 0 0 0 .12-.416v-15a.761.761 0 0 0-.12-.416.793.793 0 0 0-.34-.278z"
})); // DuoTone


const ChevronLeftDuotone = props => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  fill: "var(--i-color)",
  d: "M15.75 19.5 8.25 12l7.5-7.5v15z",
  opacity: 0.2
}), /*#__PURE__*/React.createElement("path", {
  stroke: "var(--i-color)",
  strokeLinecap: props.strokeLinecap,
  strokeLinejoin: props.strokeLinejoin,
  strokeWidth: "var(--i-s-width)",
  d: "M15.75 19.5 8.25 12l7.5-7.5v15z"
}));
/**
  Icon ChevronLeftIcon in arrows group
*/


export const ChevronLeftIcon = createIcon('ChevronLeftIcon', 'chevron-left', 'arrows', ChevronLeftOutline, ChevronLeftFill, ChevronLeftDuotone, "0 0 24 24");